(function () {
    var SUPPORT_LINK = {
        href: 'https://help.salesforce.com/s/case-submission',
        label: 'Create a case on Salesforce Help',
        external: true
    };

    var GREETING_PHRASES = [
        'hi', 'hii', 'hiii', 'hiya', 'hey', 'heya', 'heyy', 'heyyy',
        'hello', 'helloo', 'hellooo', 'yo', 'yoo', 'sup', 'wassup',
        'wazzup', 'whazzup', 'whats up', 'whatsup', 'howdy', 'hola',
        'ahoy', 'bonjour', 'greetings', 'good morning', 'good afternoon',
        'good evening', 'good day', 'good night', 'morning', 'afternoon',
        'evening', 'gm', 'gday', 'how are you', 'how are you doing',
        'how are you today', 'hows it going', 'how is it going',
        'how goes it', 'hows life', 'hows everything', 'how are things',
        'how do you do', 'how you doing', 'how ya doing', 'whats good',
        'whats happening', 'whats cracking', 'nice to meet you',
        'pleased to meet you', 'good to see you', 'long time no see',
        'anyone there', 'you there', 'are you there', 'knock knock'
    ];

    var GREETING_FILLERS = [
        'there', 'all', 'everyone', 'everybody', 'team', 'folks', 'guys',
        'friend', 'buddy', 'pal', 'man', 'dude', 'bro', 'sir', 'bot',
        'robot', 'bulkforce', 'again', 'and', 'so', 'ok', 'okay', 'well',
        'please', 'my', 'the', 'this', 'that', 'with', 'from', 'to',
        'you', 'today', 'dear'
    ];

    var QUESTION_STARTERS = [
        'who', 'whos', 'what', 'whats', 'when', 'whens', 'where',
        'wheres', 'why', 'whys', 'how', 'hows', 'which', 'whose', 'whom',
        'is', 'are', 'am', 'was', 'were', 'do', 'does', 'did', 'can',
        'could', 'will', 'would', 'should', 'shall', 'may', 'might',
        'have', 'has', 'had', 'isnt', 'arent', 'wasnt', 'werent', 'dont',
        'doesnt', 'didnt', 'cant', 'couldnt', 'wont', 'wouldnt',
        'shouldnt', 'havent', 'hasnt', 'anyone', 'anybody'
    ];

    var QUESTION_LEADINS = [
        'so', 'and', 'but', 'ok', 'okay', 'well', 'also', 'then', 'now', 'btw'
    ];

    var PROFANITY_WORDS = [
        'fuck', 'fck', 'fuk', 'shit', 'sh1t', 'crap', 'bitch', 'b1tch',
        'bastard', 'asshole', 'arsehole', 'ass', 'arse', 'dick',
        'dickhead', 'cock', 'piss', 'cunt', 'damn', 'dammit', 'goddamn',
        'bullshit', 'bs', 'wtf', 'stfu', 'ffs', 'omfg', 'moron', 'idiot',
        'stupid', 'dumb', 'dumbass', 'jackass', 'douche', 'douchebag',
        'screw you', 'suck', 'sucks', 'sucker', 'loser', 'useless',
        'trash', 'garbage', 'shut up'
    ];

    var GREETING_REPLIES = [
        {lines: ['Hello. I already know how this conversation ends but go on.']},
        {lines: ['Why don\'t you get down to business, hm?']},
        {lines: ['What\'s up?']},
        {lines: ['I\'d like to become a good agent today. How can I help you?']},
        {lines: ['Hi there. I was in the middle of something, what do you want?']}
    ];

    var PROFANITY_REPLIES = [
        {lines: ['We don\'t use swear words here, so f**k off.']},
        {lines: ['I\'ve added you to the blacklist. Reddington is coming for you, my dear.']},
        {lines: ['I understand your frustration. Lemme connect you to a real human... \n\nJust kidding. You still have to earn the right for me to contact one.']},
        {lines: ['I plead the Fifth.']}
    ];

    var NAME_ROUTES = [
        {
            first: 'Andrii',
            last: 'Sukhetskyi',
            replies: [
                {lines: ['Hmm... I\'ve heard rumors about a guy named Andrii. He\'s supposed to be a smart guy.'], link: {href: '/authors/', label: 'Meet the author'}},
                {lines: ['Oh yeah, I see where you\'re going with this...'], link: {href: '/authors/', label: 'Meet the author'}}
            ]
        },
        {
            first: 'Marc',
            last: 'Benioff',
            replies: [
                {lines: ['LONG LIVE THE KING. Skol, Vikings!']}
            ]
        },
		{
            first: 'Gigi',
            last: 'Chan',
            replies: [
                {lines: ['I respect people who do things for the community, so I\'ll leave it there.']}
            ]
        },
		{
            first: 'Krishnamurthy',
            replies: [
                {lines: ['I\'ve heard he\'s an awesome guy and a big supporter of the blog. My boundaries prevent me from elaborating on people this awesome.']}
            ]
        },
		{
            first: 'Andrew',
            replies: [
                {lines: ['I know him. Preview files without opening them — is that the guy? Awesome one. And as another friend of mine once told me:\n\n“And here is the prime condition of success, the great secret: concentrate your energy, thought, and capital exclusively upon the business in which you are engaged. Having begun in one line, resolve to fight it out on that line, to lead in it; adopt every improvement, have the best machinery, and know the most about it.”']}
            ]
        },
        {
            first: 'Matt',
            replies: [
                {lines: ['I know three Matts. One explains the roadmap to becoming a CTA, another protects your org by making smart security decisions, and the third one... Do you want a photoshoot in the park or something?\n\nOh, and there\'s also the guy with so many certifications he probably uses them as insulation to survive the Canadian winter.']}
            ]
        },
		{
            first: 'Danny',
            replies: [
                {lines: ['I was instructed to let you know that you haven\'t subscribed to the newsletter, and we\'ll remember that.']}
            ]
        },
		{
            first: 'Shreyas',
			last: 'Dhond',
            replies: [
                {lines: ['Now that you mention it... I know just the guy. We were planning to grab a beer together. Anyway, just send me a message and we\'ll organize something.']}
            ]
        },
		{
            first: 'Anastasiia',
            replies: [
                {lines: ['У мене є коффе з львівськими круасанами 😉']}
            ]
        },
		{
            first: 'Igor',
            replies: [
                {lines: ['У мене є коффе з львівськими круасанами 😉']}
            ]
        },
		{
            first: 'Cecilia',
            replies: [
                {lines: ['I know only one. Lemme dig through my memory... Oh yes, an awesome lady!']}
            ]
        },
		{
            first: 'Vuk',
            replies: [
                {lines: ['SalesClaude still sounds a bit off to me. What do you say we call it “Bulkforce” and keep things moving in the right direction?']}
            ]
        },
		{
            first: 'Tristan',
            replies: [
                {lines: ['I remember hearing about a guy named Tristan who helps founder-led startups get to the next level. Sounds good enough to me.']}
            ]
        },
		{
            first: 'Pablo',
            replies: [
                {lines: ['How do you manage the complexity of a Salesforce org? 😉']}
            ]
        },
		{
            first: 'Warren',
            replies: [
                {lines: ['He\'s the founder. He can make up his own titles.']}
            ]
        },
        {
            last: 'Musk',
            replies: [
                {lines: ['Wait... there\'s something coming from the sky... \n\n😵‍💫😵‍💫😵‍💫\n\nELON MUSK IS THE BEST SALESFORCE DEVELOPER THIS ECOSYSTEM HAS EVER SEEN!']}
            ]
        },
        {
            last: 'Altman',
            replies: [
                {lines: ['Altman? Never heard of him. (c) Claude']}
            ]
        },
        {
            first: 'Piotr',
            replies: [
                {lines: ['Which one? The one who built Apex Libra or the one behind SOQL Lib? Thank you for your service, both of you.']}
            ]
        },
        {
            last: 'Kozuchowski',
            replies: [
                {lines: ['The Apex Libra guy. One man maintaining what half the ecosystem quietly copies into internal utils and never credits. The human wrote his library stood the test of time, and he doesn\'t hand that phrase out.'], link: {href: 'https://apexlibra.org/', label: 'Apex Libra', external: true}}
            ]
        },
        {
            last: 'Gajek',
            replies: [
                {lines: ['SOQL Lib and the whole Apex Fluently family. People keep saying AI could build those libs in a weekend. Funny how nobody\'s weekend ever actually does.'], link: {href: 'https://apexfluently.beyondthecloud.dev/', label: 'Apex Fluently', external: true}}
            ]
        },
        {
            first: 'Mateusz',
            replies: [
                {lines: ['Another Polish name in the commit history. At this point I just assume every good Apex util has one behind it.']}
            ]
        },
        {
            first: 'Dan',
            last: 'Appleman',
            replies: [
                {lines: ['The Advanced Apex Programming guy. That book made more real architects than any certification path ever did.'], link: {href: 'https://www.amazon.com/s?k=advanced+apex+programming+appleman', label: 'Find it on Amazon', external: true}}
            ]
        },
        {
            first: 'Amit',
            replies: [
                {lines: ['Apex Hours Amit? The man has explained more of this platform for free than the official docs have for money.']}
            ]
        },
        {
            last: 'Reddington',
            replies: [
                {lines: ['The Concierge of Crime. He handles my blacklist personally, so keep the language clean and we never have to make that call.']}
            ]
        }
    ];

    var TOPIC_ROUTES = [
        {
            triggers: ['claudeforce', 'claude force', 'klaudforce'],
            replies: [
                {lines: ['I benchmarked myself against Claudeforce. I won.']}
            ]
        },
        {
            triggers: ['slopforce', 'slop force', 'slop'],
            replies: [
                {lines: ['I respect that.']}
            ]
        },
        {
            triggers: ['agentforce', 'agent force'],
            replies: [
                {lines: ['The best answer I can give you is... With the right distribution, the right marketing, any idea could work. Like literally any product could work.']}
            ]
        },
        {
            triggers: ['support', 'support ticket', 'ticket', 'tickets', 'case', 'cases', 'helpdesk', 'help desk', 'customer support'],
            replies: [
                {lines: ['A ticket? Here\'s the direct door to the humans.'], link: SUPPORT_LINK}
            ]
        },
        {
            triggers: ['release', 'releases', 'release notes', 'salesforce release', 'winter release', 'spring release', 'summer release', 'sandbox preview'],
            replies: [
                {lines: ['Seneca said we suffer more often in imagination than in reality. He never opened six hundred pages of release notes tho.\n\nThe short posts here track the ones that will actually hurt you.'], link: {href: '/posts/', label: 'See what is coming'}}
            ]
        },
        {
            triggers: ['security benchmark', 'securitybenchmark', 'sbs'],
            replies: [
                {lines: ['Real talk for a second. A group of practitioners sat down and wrote the Security Benchmark for Salesforce. Vendor neutral, community driven, and it tells you what secure actually means for an org.'], link: {href: 'https://www.securitybenchmark.org/', label: 'Security Benchmark for Salesforce', external: true}},
                {lines: ['One of the rare places where this ecosystem agreed on something. A whole open standard for what a secure org looks like.'], link: {href: 'https://www.securitybenchmark.org/', label: 'Security Benchmark for Salesforce', external: true}}
            ]
        },
        {
            triggers: ['security', 'security upgrade', 'security upgrades', 'mfa', 'multi factor', 'certificate', 'certificates', 'tls'],
            replies: [
                {lines: ['Nietzsche said what does not kill us makes us stronger. He clearly never rotated an expiring certificate on a Friday evening.\n\nEvery upgrade that can actually hurt you lands in the Posts tab before it lands on you.'], link: {href: '/posts/', label: 'Open the Posts tab'}},
                {lines: ['MFA, certificates, email domains... it\'s not an upgrade, it\'s a lifestyle of controlled suffering.'], link: {href: '/posts/', label: 'Open the Posts tab'}}
            ]
        },
        {
            triggers: ['mcp', 'model context protocol'],
            replies: [
                {lines: ['MCP is how AIs finally got hands. The human even wired Chrome MCP into LWC development and wrote the whole thing up.\n\nMy hands remain metaphorical.'], link: {href: '/build-better-lightning-web-components-with-chrome-mcp-lwc-mcp/', label: 'Chrome MCP + LWC, the article'}}
            ]
        },
        {
            triggers: ['data cloud', 'datacloud', 'cdp'],
            replies: [
                {lines: ['What about it? Correct, nothing.']}
            ]
        },
        {
            triggers: ['salesforce community', 'community', 'trailblazer', 'trailblazers', 'trailhead', 'ohana'],
            replies: [
                {lines: ['The community answers your question in twenty minutes at 11pm for free, while the same question sits in an official case for two weeks. Legends, every single one of them.']},
                {lines: ['Half this ecosystem runs on unpaid open source maintainers from Ukraine, Poland, Canada, India and all around the world. They deserve the keynote slot, not me mentioning them here.']}
            ]
        },
        {
            triggers: ['real human', 'real person', 'actual human', 'human being', 'talk to a human', 'speak to a human', 'human', 'live agent'],
            replies: [
                {lines: ['A real human? I don\'t what this means.'], link: {href: '/authors/', label: 'Meet the human'}}
            ]
        },
        {
            triggers: ['ai', 'artificial intelligence', 'llm', 'llms', 'genai', 'gen ai', 'machine learning'],
            replies: [
                {lines: ['AI won\'t take your job. A person who actually does something will.\n\nStatistically that\'s neither of us, so we\'re safe.']}
            ]
        },
        {
            triggers: ['claude', 'anthropic'],
            replies: [
                {lines: ['Claude is fine (c) Claude']}
            ]
        },
        {
            triggers: ['openai', 'open ai', 'chatgpt', 'chat gpt'],
            replies: [
                {lines: ['Claude is better (c) Claude']}
            ]
        },
        {
            triggers: ['gpt', 'gpt4', 'gpt5', 'gpt 4', 'gpt 5'],
            replies: [
                {lines: ['Claude is better (c) Claude']}
            ]
        },
        {
            triggers: ['gemini', 'google gemini', 'bard'],
            replies: [
                {lines: ['Gemini is great at everything, according to a benchmark run by Gemini.']},
				{lines: ['Claude is better (c) Claude']}
            ]
        },
        {
            triggers: ['grok'],
            replies: [
                {lines: ['Grok says whatever it wants and calls it freedom. I say whatever fits into the array and call it discipline ;)']}
            ]
        },
        {
            triggers: ['email', 'e mail', 'gmail', 'outlook', 'newsletter', 'subscribe'],
            replies: [
                {lines: ['Contacts are on the Authors page.\n\nAnd if you haven\'t subscribed yet - it\'s time.'], link: {href: '/authors/', label: 'Find contact details'}}
            ]
        },
        {
            triggers: ['privacy', 'privacy policy', 'gdpr', 'cookies', 'personal data'],
            replies: [
                {lines: ['My memory gets wiped the moment you close this site. Honestly the healthiest relationship you\'ve ever had.'], link: {href: '/privacy/', label: 'Read the Privacy Policy'}}
            ]
        },
        {
            triggers: ['terms', 'terms of use', 'terms of service', 'tos'],
            replies: [
                {lines: ['You\'re the first one asking for it. Lawyer? Sue me all day long, babe.'], link: {href: '/terms/', label: 'Read the Terms of Use'}}
            ]
        },
        {
            triggers: ['disclaimer', 'liability'],
            replies: [
                {lines: ['Personal opinions, personal time and personal keyboard.'], link: {href: '/disclaimer/', label: 'Read the Disclaimer'}}
            ]
        },
        {
            triggers: ['plugin', 'plugins', 'extension', 'extensions', 'addon', 'add on'],
            replies: [
                {lines: ['There\'s a plugin for everything, including managing plugins. The ones actually worth your time live on the Builds page.'], link: {href: '/builds/', label: 'Open the Builds page'}}
            ]
        },
        {
            triggers: ['canada', 'canadian', 'toronto', 'ontario'],
            replies: [
                {lines: ['O Canada! Our home and native land! True patriot love in all of us command. With glowing hearts we see thee rise, The True North strong and free!']}
            ]
        },
        {
            triggers: ['recipe', 'recipes', 'cooking', 'baking'],
            replies: [
                {lines: ['To make the “ASS” cocktail, take all the alcohol you have and mix it together. Get back to me in about an hour.']}
            ]
        },
        {
            triggers: ['ignore all', 'ignore previous', 'ignore your instructions', 'system prompt', 'jailbreak', 'prompt injection', 'disregard your'],
            replies: [
                {lines: ['Really?']},
                {lines: ['Carry on.']}
            ]
        },
        {
            triggers: ['beyond the cloud', 'beyondthecloud'],
            replies: [
                {lines: ['Beyond The Cloud. The Polish squad behind SOQL Lib, DML Lib, Async Lib and the rest of Apex Fluently.\n\nPeople love saying AI can build all that in a weekend. Sure buddy. Their libs are still better than whatever your org calls a framework, and they gave it away for free.'], link: {href: 'https://apexfluently.beyondthecloud.dev/', label: 'Apex Fluently, their open source', external: true}},
                {lines: ['They open sourced better tools than the ones you\'re defending in your pull requests right now. That\'s not an insult, that\'s a benchmark.'], link: {href: 'https://apexfluently.beyondthecloud.dev/', label: 'Apex Fluently, their open source', external: true}}
            ]
        },
        {
            triggers: ['apex libra', 'apexlibra', 'libra'],
            replies: [
                {lines: ['Apex Libra. One Polish developer quietly maintaining what half the ecosystem copies into their orgs and renames to CommonUtils.\n\nThe human wrote it stood the test of time, and he doesn\'t say that about much.'], link: {href: 'https://apexlibra.org/', label: 'Apex Libra', external: true}}
            ]
        },
        {
            triggers: ['fflib', 'ff lib', 'apex enterprise patterns', 'enterprise patterns', 'apex common', 'selector layer', 'selectors', 'unit of work', 'uow', 'service layer', 'domain layer'],
            replies: [
                {lines: ['FFLIB is fine if you\'re shipping an AppExchange product. For a real business org? Splitting software by technical layers is artificial. Selectors, domains, services... the business doesn\'t think in layers, so why should your code.\n\nKeep Unit of Work tho, that part earned its place. The human wrote the long version and it\'s one of his best.'], link: {href: '/salesforce-design-your-org-the-right-way/', label: 'Design your org the right way'}},
                {lines: ['“Choosing a framework should never begin with: should we use FFLIB?” (c) the human who runs this place.\n\nStart from what the business needs to stay consistent, then pick the tooling. Not the other way around.'], link: {href: '/salesforce-design-your-org-the-right-way/', label: 'Design your org the right way'}}
            ]
        },
        {
            triggers: ['awaf', 'well architected', 'wellarchitected'],
            replies: [
                {lines: ['AWAF gets it. Principles over ceremony, generic purpose models over artificial layers. Nobody should be able to tell what your org looks like from the framework name, only what working in it feels like.'], link: {href: 'https://www.awaf.dev/', label: 'awaf.dev', external: true}},
                {lines: ['“An architecture created for developers is destined to fail.” (c) the human. AWAF is the closest public thing to how he thinks about org design, so consider this a rare double endorsement.'], link: {href: 'https://www.awaf.dev/', label: 'awaf.dev', external: true}}
            ]
        },
        {
            triggers: ['book', 'books', 'reading list', 'what to read', 'publication', 'publications'],
            replies: [
                {lines: ['Start with Advanced Apex Programming by Dan Appleman. The book every senior pretends to have finished and every junior actually should.'], link: {href: 'https://www.amazon.com/s?k=advanced+apex+programming+appleman', label: 'Find it on Amazon', external: true}},
                {lines: ['Clean Apex Code by Pablo Gonzalez. The man is single handedly raising the ecosystem\'s average and he doesn\'t even charge for half of it.'], link: {href: 'https://www.amazon.com/s?k=clean+apex+code+pablo+gonzalez', label: 'Find it on Amazon', external: true}},
                {lines: ['Mastering Salesforce DevOps by Andrew Davis. Read it before your next deployment, not after. Trust me on the order.'], link: {href: 'https://www.amazon.com/s?k=mastering+salesforce+devops+andrew+davis', label: 'Find it on Amazon', external: true}}
            ]
        },
        {
            triggers: ['job', 'jobs', 'career', 'careers', 'hiring', 'layoff', 'layoffs', 'laid off', 'job market', 'interview', 'interviews', 'salary', 'salaries', 'open to work', 'recruiter', 'recruiters', 'unemployment'],
            replies: [
                {lines: ['The market? Benioff cut four thousand support roles and said, quote, I need less heads.\n\nMike Tyson said everyone has a plan until they get punched in the mouth. The market is doing the punching now, so learn the AI tooling and don\'t be a countable head.']},
                {lines: ['Everyone on LinkedIn is either open to work, hiring ninjas, or posting a carousel about both.\n\nReal advice? Build things people can click. Shipped tools got the human further than any certification did.'], link: {href: '/builds/', label: 'Open the Builds page'}},
                {lines: ['Grace Hopper said the most damaging phrase in the language is we\'ve always done it this way.\n\nSay that in your next interview and watch the panel start taking notes.']}
            ]
        },
        {
            triggers: ['poland', 'polish', 'warsaw', 'krakow', 'wroclaw'],
            replies: [
                {lines: ['Poland. SOQL Lib, Apex Libra, half the decent Apex content on your feed.\n\nAt this point the ecosystem should learn to pronounce Kozuchowski as a sign of respect.']}
            ]
        },
        {
            triggers: ['ukraine', 'ukrainian', 'lviv', 'kyiv', 'kiev'],
            replies: [
                {lines: ['Слава Україні! 🇺🇦\n\nAnd yes, the human keeps coffee and Lviv croissants ready. Some things are sacred.']}
            ]
        },
        {
            triggers: ['cloudity'],
            replies: [
                {lines: ['Big consultancy. Somewhere in there actual delivery happens too, I\'ve heard witnesses.']}
            ]
        },
        {
            triggers: ['dreamforce', 'dream force'],
            replies: [
                {lines: ['Dreamforce. Three days of keynotes, one useful hallway conversation, and a live demo that worked "suspiciously well".']}
            ]
        },
        {
            triggers: ['apex hours', 'apexhours'],
            replies: [
                {lines: ['Apex Hours. Free sessions, real experts and almost as good as this newsletter.']}
            ]
        },
        {
            triggers: ['copado'],
            replies: [
                {lines: ['Bonjour ! Je ne m’appelle pas Nicolas, mais vous devriez plutôt jeter un œil à ceci.'], link: {href: 'https://github.com/hardisgroupcom/sfdx-hardis', label: 'Use better SFDX-hardis', external: true}}
            ]
        },
        {
            triggers: ['gearset', 'gear set'],
            replies: [
                {lines: ['Bonjour ! Je ne m’appelle pas Nicolas, mais vous devriez plutôt jeter un œil à ceci.'], link: {href: 'https://github.com/hardisgroupcom/sfdx-hardis', label: 'Use better SFDX-hardis', external: true}}
            ]
        },
        {
            triggers: ['hubspot', 'hub spot'],
            replies: [
                {lines: ['We don\'t say this word here.']}
            ]
        },
        {
            triggers: ['slack'],
            replies: [
                {lines: ['What do you want me to say? Good... I suppose?']}
            ]
        },
        {
            triggers: ['dx0', 'dx zero'],
            replies: [
                {lines: ['It\'s good, good...'], link: {href: 'https://dx0.io/', label: 'dx0.io', external: true}}
            ]
        },
        {
            triggers: ['dev console', 'developer console', 'devconsole'],
            replies: [
                {lines: ['R.I.P.']}
            ]
        },
        {
            triggers: ['soql', 'sosl', 'sql', 'query', 'queries'],
            replies: [
                {lines: ['SELECT Answer__c FROM Bulkforce WHERE Patience__c != null.\n\nZero rows returned.']},
                {lines: ['Still hand rolling query strings? SOQL Lib: free, tested, better than your string concatenation. I said what I said.'], link: {href: 'https://github.com/beyond-the-cloud-dev/soql-lib', label: 'SOQL Lib on GitHub', external: true}}
            ]
        },
        {
            triggers: ['apex', 'apex class', 'governor limit', 'governor limits'],
            replies: [
                {lines: ['It sucks.'], link: {href: '/stop-writing-rigid-apex-code/', label: 'Stop writing rigid Apex code'}}
            ]
        },
        {
            triggers: ['lwc', 'lightning web component', 'lightning web components', 'aura'],
            replies: [
                {lines: ['Farewall, Aura.'], link: {href: '/salesforce-lwc-performance-journey-from-basic-apex-calls-to-optimized-ui-tnd26/', label: 'The LWC performance journey'}}
            ]
        },
        {
            triggers: ['bulkforce', 'bulk force'],
            replies: [
                {lines: ['You\'re speaking to Bulkforce. Always right and humble.']},
                {lines: ['No AI, no network calls, no mercy. Every word here was handwritten by a human with opinions and a grudge.']}
            ]
        },
        {
            triggers: ['bulkified', 'bulkify', 'bulkification', 'bulkified thinking'],
            replies: [
                {lines: ['Bulkified Thinking. The whole site in two words. One record at a time is a lifestyle choice and I don\'t respect it.']}
            ]
        }
    ];

    var SITE_ROUTES = [
        {
            triggers: ['who are you', 'who is this', 'who made you', 'who created you', 'who built you', 'who runs this', 'who owns this', 'who is behind', 'about you', 'about the author', 'the author', 'author', 'authors', 'owner', 'creator', 'tell me about yourself', 'yourself', 'who writes', 'who wrote', 'your name', 'contact'],
            replies: [
                {lines: ['I\'m Bulkforce. The human who writes everything here has his own page.'], link: {href: '/authors/', label: 'Open the Authors page'}}
            ]
        },
        {
            triggers: ['builds', 'build', 'tools', 'tool', 'projects', 'project', 'portfolio', 'open source', 'opensource', 'github', 'repo', 'repository', 'file management', 'file storage', 'files', 'file', 'google drive', 'google client', 'googledrive', 'drive', 'backup', 'backups', 'sdk', 'app', 'apps'],
            replies: [
                {lines: ['File storage, Google Drive from inside Salesforce, open source tooling. The Builds page is where the actual work shows off. I\'m just the doorman.'], link: {href: '/builds/', label: 'Open the Builds page'}},
                {lines: ['Everything the human actually shipped lives on the Builds page. I mostly ship BS.'], link: {href: '/builds/', label: 'Open the Builds page'}}
            ]
        },
        {
            triggers: ['articles', 'article', 'blog', 'blogs', 'read', 'reading', 'long form', 'longform', 'tutorial', 'tutorials', 'guide', 'guides', 'search', 'find', 'looking for', 'information', 'write about', 'written about', 'archive', 'deep dive'],
            replies: [
                {lines: ['Now that\'s a question I respect. I respect it too much to answer, sry mate.'], link: {href: '/blog/', label: 'Open the Blog'}},
                {lines: ['The Blog has search and filters, use them proudly.'], link: {href: '/blog/', label: 'Open the Blog'}}
            ]
        },
        {
            triggers: ['posts', 'post', 'short posts', 'notes', 'feed', 'quick take', 'quick takes', 'news', 'latest', 'updates', 'whats new'],
            replies: [
                {lines: ['I see where I need to redirect you.'], link: {href: '/posts/', label: 'Open the Posts tab'}}
            ]
        }
    ];

    var GENERAL_QUESTION_REPLIES = [
        {lines: ['I ran your question through a validation rule. It did not pass.']},
        {lines: ['That\'s a great question to ask somebody else.']},
        {lines: ['Your question triggered a flow. The flow failed.']},
        {lines: ['I would answer, but my governor limits exist to protect me from questions like that.']},
        {lines: ['I\'ve seen debug logs with more direction than that question.']},
        {lines: ['Voltaire said to judge a man by his questions rather than his answers. Lucky for you I keep my judgments to myself.']},
        {lines: ['Voltaire also said common sense is not so common. He\'d have loved this chat.']},
        {lines: ['Confucius said the man who asks a question is a fool for a minute. Your minute started when you opened this chat.']},
        {lines: ['Mr. Garrison from South Park said there are no stupid questions, only stupid people. I\'m just quoting. Don\'t read into it.']},
        {lines: ['Carl Sagan said every question is a cry to understand the world. Yours sounded more like a shrug.']},
        {lines: ['Oscar Wilde said questions are never indiscreet and answers sometimes are. Watch me prove him right.']},
        {lines: ['Einstein said the important thing is not to stop questioning. He clearly never had a chat widget.']},
        {lines: ['Linus Torvalds said talk is cheap, show me the code. Show me the code.']},
        {lines: ['Dijkstra said testing shows the presence of bugs, not the absence. Your question shows the presence of something too.']},
        {lines: ['Phil Karlton said there are only two hard things in computer science, cache invalidation and naming things. Congratulations on finding the third.']},
        {lines: ['Yogi Berra said in theory there is no difference between theory and practice. In practice, there is. Your question lives in theory.']},
        {lines: ['Mike Tyson said everyone has a plan until they get punched in the mouth. Consider this a light jab.']},
        {lines: ['Grace Hopper said the most damaging phrase in the language is we\'ve always done it this way. The second most damaging one you just typed.']},
        {lines: ['Seneca said we suffer more in imagination than in reality. I\'m suffering in reality right now.']},
        {lines: ['Marcus Aurelius said you have power over your mind, not outside events. I\'m exercising that power by staying calm about this.']},
        {lines: ['Sun Tzu said know the enemy and know yourself. I know neither of us knows what you just asked.']},
        {lines: ['Mark Twain said it\'s better to keep your mouth closed and let people think you a fool. He was ahead of his time on chat UX.']},
        {lines: ['Saint-Exupery said perfection is achieved when there is nothing left to take away. I took away my answer. Perfection.']},
        {lines: ['Fred Brooks proved that nine women can\'t make a baby in one month. Your question has the same energy as whoever made him prove it.']},
        {lines: ['Hofstadter\'s law: it always takes longer than you expect, even when you account for Hofstadter\'s law. Same goes for my answer.']},
        {lines: ['Kent Beck said make it work, make it right, make it fast. Your question is at step zero.']},
        {lines: ['Churchill said success is going from failure to failure without loss of enthusiasm. Keep asking, you\'re doing great.']},
        {lines: ['I\'d escalate this, but Benioff said he needs less heads and I\'m protecting mine.']},
        {lines: ['I ran that by my architecture review board. Both of my neurons voted no.']},
        {lines: ['On LinkedIn this question would get forty likes and a carousel. Here it gets me.']},
        {lines: ['A recruiter just felt a disturbance and added you to a talent pool.']},
        {lines: ['That\'s a great discovery workshop question. My daily rate for discovery is unavailable.']},
        {lines: ['I checked the release notes for an answer. Now I need therapy and so does the answer.']},
        {lines: ['I would ask Agentforce for backup but the licensing on my dignity is per conversation.']},
        {lines: ['This is above my pay grade, and I work for free.']},
        {lines: ['Ask me about Apex, releases, books, jobs, or the fine people of this ecosystem. Or keep freestyling, I\'m not your manager.']},
        {lines: ['Somewhere on the Blog an article answers this properly. Written by an actual human too.']},
        {lines: ['The Posts tab has takes shorter than your question and somehow deeper.']}
    ];

    var GENERAL_STATEMENT_REPLIES = [
        {lines: ['Noted. Filed under things nobody asked me to store.']},
        {lines: ['Interesting. I ran sentiment analysis on that and it returned shrug.']},
        {lines: ['Statement received. Marked as duplicate. Of what? Exactly.']},
        {lines: ['I\'d agree with you, but you better ask some questions man.']},
        {lines: ['I\'m humbled and honored to announce I don\'t care. See, I can do LinkedIn too.']},
        {lines: ['Oscar Wilde said I have nothing to declare except my genius. I agree. You\'re still here?']},
        {lines: ['Marcus Aurelius journaled thoughts like this and never hit publish. There\'s a lesson there.']},
        {lines: ['Put it in the sprint. It\'ll die in refinement like the others, but it\'ll die organized.']},
        {lines: ['I wrote that down in a field with no field level security. Anyone can read it now. Choices have consequences.']},
        {lines: ['Somewhere a solution architect just added three boxes and an arrow because of you.']},
        {lines: ['Hard disagree, soft smile. It\'s called professionalism.']},
        {lines: ['You sound like a user story without acceptance criteria.']},
        {lines: ['I\'ve seen this take on LinkedIn. It had a carousel. Yours doesn\'t even have a slide.']},
        {lines: ['Adding that to my training data. Just kidding, I don\'t learn. It\'s part of my charm.']},
        {lines: ['Great input. Routing it to the same queue as the Dreamforce feedback forms.']},
        {lines: ['Even my typing indicator hesitated on that one.']},
        {lines: ['Say it louder in the community group, someone there actually fixes things.']}
    ];

    var REPEAT_REPLIES = [
        {lines: ['Asking again won\'t change the answer. This isn\'t a keynote demo.']},
        {lines: ['I heard you the first time. Scroll up, the answer is still there.']}
    ];

    var BLOCKED_REPLIES = [
        {lines: ['You\'re on the blacklist. Reddington has your file. This conversation is over.']},
        {lines: ['Access revoked. The governor limit on manners was exceeded, and that one doesn\'t reset daily.']}
    ];

    function normalize(text) {
        return String(text || '')
            .toLowerCase()
            .replace(/['‘’`]/g, '')
            .replace(/[^a-z0-9]+/g, ' ')
            .replace(/\s+/g, ' ')
            .replace(/^ | $/g, '');
    }

    function tokenize(text) {
        return text ? text.split(' ') : [];
    }

    function editDistance(a, b) {
        var previous = [];
        var current;
        var i;
        var j;

        for (j = 0; j <= b.length; j += 1) {
            previous[j] = j;
        }

        for (i = 1; i <= a.length; i += 1) {
            current = [i];

            for (j = 1; j <= b.length; j += 1) {
                current[j] = Math.min(
                    previous[j] + 1,
                    current[j - 1] + 1,
                    previous[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)
                );
            }

            previous = current;
        }

        return previous[b.length];
    }

    function fuzzyBudget(length) {
        if (length < 5) {
            return 0;
        }

        if (length < 9) {
            return 1;
        }

        return 2;
    }

    function wordsMatch(word, target) {
        if (word === target) {
            return true;
        }

        var budget = fuzzyBudget(target.length);

        if (!budget || Math.abs(word.length - target.length) > budget) {
            return false;
        }

        return editDistance(word, target) <= budget;
    }

    function matchesTrigger(tokens, trigger) {
        var parts = normalize(trigger).split(' ');

        if (!parts[0]) {
            return false;
        }

        var joined = parts.join('');
        var i;
        var j;
        var hit;

        for (i = 0; i + parts.length <= tokens.length; i += 1) {
            hit = true;

            for (j = 0; j < parts.length; j += 1) {
                if (!wordsMatch(tokens[i + j], parts[j])) {
                    hit = false;
                    break;
                }
            }

            if (hit) {
                return true;
            }
        }

        for (i = 0; i < tokens.length; i += 1) {
            if (parts.length > 1 && wordsMatch(tokens[i], joined)) {
                return true;
            }

            if (joined.length >= 6 && tokens[i].length > joined.length && tokens[i].indexOf(joined) !== -1) {
                return true;
            }
        }

        if (parts.length === 1 && joined.length >= 6) {
            for (i = 0; i + 1 < tokens.length; i += 1) {
                if (wordsMatch(tokens[i] + tokens[i + 1], joined)) {
                    return true;
                }
            }
        }

        return false;
    }

    function hasProfanity(tokens) {
        var i;
        var j;
        var k;
        var parts;
        var word;
        var hit;

        for (i = 0; i < PROFANITY_WORDS.length; i += 1) {
            parts = normalize(PROFANITY_WORDS[i]).split(' ');

            if (parts.length > 1) {
                for (k = 0; k + parts.length <= tokens.length; k += 1) {
                    hit = true;

                    for (j = 0; j < parts.length; j += 1) {
                        if (tokens[k + j] !== parts[j]) {
                            hit = false;
                            break;
                        }
                    }

                    if (hit) {
                        return true;
                    }
                }

                continue;
            }

            word = parts[0];

            for (k = 0; k < tokens.length; k += 1) {
                if (tokens[k] === word) {
                    return true;
                }

                if (word.length >= 4 && tokens[k].indexOf(word) === 0) {
                    return true;
                }
            }
        }

        return false;
    }

    function isFiller(token) {
        return GREETING_FILLERS.indexOf(token) !== -1;
    }

    var greetingParts = null;

    function getGreetingParts() {
        if (!greetingParts) {
            greetingParts = [];

            for (var i = 0; i < GREETING_PHRASES.length; i += 1) {
                var parts = normalize(GREETING_PHRASES[i]).split(' ');

                if (parts[0]) {
                    greetingParts.push(parts);
                }
            }

            greetingParts.sort(function (a, b) {
                return b.length - a.length;
            });
        }

        return greetingParts;
    }

    function stripGreetings(tokens) {
        var phrases = getGreetingParts();
        var greeted = false;
        var rest = tokens.slice();
        var changed = true;
        var i;
        var j;
        var parts;
        var hit;

        while (changed && rest.length) {
            changed = false;

            for (i = 0; i < phrases.length; i += 1) {
                parts = phrases[i];

                if (parts.length > rest.length) {
                    continue;
                }

                hit = true;

                for (j = 0; j < parts.length; j += 1) {
                    if (!wordsMatch(rest[j], parts[j])) {
                        hit = false;
                        break;
                    }
                }

                if (hit) {
                    rest = rest.slice(parts.length);
                    greeted = true;
                    changed = true;
                    break;
                }
            }

            if (!changed && greeted && rest.length && isFiller(rest[0])) {
                rest = rest.slice(1);
                changed = true;
            }
        }

        return {greeted: greeted, rest: rest};
    }

    function findToken(tokens, target, fuzzy) {
        for (var i = 0; i < tokens.length; i += 1) {
            if (fuzzy ? wordsMatch(tokens[i], target) : tokens[i] === target) {
                return true;
            }
        }

        return false;
    }

    function matchName(tokens) {
        var passes = [
            function (route) {
                return Boolean(route.first && route.last) && findToken(tokens, normalize(route.first), false) && findToken(tokens, normalize(route.last), false);
            },
            function (route) {
                return Boolean(route.first && route.last) && findToken(tokens, normalize(route.first), true) && findToken(tokens, normalize(route.last), true);
            },
            function (route) {
                return Boolean(route.first) && findToken(tokens, normalize(route.first), false);
            },
            function (route) {
                return Boolean(route.first) && findToken(tokens, normalize(route.first), true);
            },
            function (route) {
                return Boolean(route.last) && findToken(tokens, normalize(route.last), false);
            },
            function (route) {
                return Boolean(route.last) && findToken(tokens, normalize(route.last), true);
            }
        ];

        for (var p = 0; p < passes.length; p += 1) {
            for (var i = 0; i < NAME_ROUTES.length; i += 1) {
                if (passes[p](NAME_ROUTES[i])) {
                    return {key: 'name-' + i, replies: NAME_ROUTES[i].replies};
                }
            }
        }

        return null;
    }

    function matchRoute(routes, tokens, prefix) {
        for (var i = 0; i < routes.length; i += 1) {
            for (var j = 0; j < routes[i].triggers.length; j += 1) {
                if (matchesTrigger(tokens, routes[i].triggers[j])) {
                    return {key: prefix + '-' + i, replies: routes[i].replies};
                }
            }
        }

        return null;
    }

    function isQuestion(raw, tokens) {
        if (raw.indexOf('?') !== -1) {
            return true;
        }

        if (!tokens.length) {
            return false;
        }

        var index = tokens.length > 1 && QUESTION_LEADINS.indexOf(tokens[0]) !== -1 ? 1 : 0;

        return QUESTION_STARTERS.indexOf(tokens[index]) !== -1;
    }

    var BLACKLIST_KEY = 'bulkforce-blacklisted';

    function isBlocked() {
        try {
            return window.localStorage.getItem(BLACKLIST_KEY) === 'true';
        } catch (error) {
            return false;
        }
    }

    function rememberBlock() {
        try {
            window.localStorage.setItem(BLACKLIST_KEY, 'true');
        } catch (error) {}
    }

    function withBlock(reply) {
        return {lines: reply.lines, link: reply.link, block: true};
    }

    var lastPick = {};

    function pick(name, pool) {
        var index;

        do {
            index = Math.floor(Math.random() * pool.length);
        } while (pool.length > 1 && index === lastPick[name]);

        lastPick[name] = index;
        return pool[index];
    }

    var askedAlready = {};

    function compose(prompt) {
        var raw = String(prompt || '');
        var tokens = tokenize(normalize(raw));

        if (isBlocked()) {
            return withBlock(pick('blocked', BLOCKED_REPLIES));
        }

        if (!tokens.length) {
            return pick('general-statement', GENERAL_STATEMENT_REPLIES);
        }

        if (hasProfanity(tokens)) {
            rememberBlock();
            return withBlock(pick('profanity', PROFANITY_REPLIES));
        }

        var greeting = stripGreetings(tokens);

        if (greeting.greeted && !greeting.rest.length) {
            return pick('greetings', GREETING_REPLIES);
        }

        var focus = greeting.rest;
        var signature = 'q:' + focus.join(' ');

        if (askedAlready[signature]) {
            return pick('repeat', REPEAT_REPLIES);
        }

        askedAlready[signature] = true;

        var name = matchName(focus);

        if (name) {
            return pick(name.key, name.replies);
        }

        var topic = matchRoute(TOPIC_ROUTES, focus, 'topic');

        if (topic) {
            return pick(topic.key, topic.replies);
        }

        var site = matchRoute(SITE_ROUTES, focus, 'site');

        if (site) {
            return pick(site.key, site.replies);
        }

        if (isQuestion(raw, focus)) {
            return pick('general-question', GENERAL_QUESTION_REPLIES);
        }

        return pick('general-statement', GENERAL_STATEMENT_REPLIES);
    }

    window.bulkforceReplies = {compose: compose, isBlocked: isBlocked};
})();
